module.exports = __webpack_public_path__ + "static/9-d90fdce7d4c57b2971208155f5c59ce2.jpeg";